import { getArticleList, getVideoList } from '@this/services/article';
const state = {
  prizeStaticList: [],
  prizeList: [],
  staticList: [],
  videoList: [],
  videoMetal: 0,
  videoInfo: {},
  videoShow: false,
};

const mutations = {
  setPrizeStaticList(state, list) {
    state.prizeStaticList = list;
  },
  setPrizeList(state, list) {
    state.prizeList = list;
  },
  setStaticList(state, list) {
    state.staticList = list;
  },
  setVideoList(state, list) {
    state.videoList = list;
  },
  setVideoMetal(state, number) {
    state.videoMetal = number;
  },
  setVideoInfo(state, obj) {
    state.videoInfo = obj;
  },
  setVideoShow(state, bool) {
    state.videoShow = bool;
  },
};

const actions = {
  // 事件
  // 文章
  getArticleList({ commit }) {
    return getArticleList().then((res) => {
      const prizeList = res.data.xckx.filter((item) => item.text);
      const staticList = res.data.xcjs.filter((item) => item.text);
      commit('setPrizeStaticList', [...prizeList, ...staticList]);
      commit('setPrizeList', prizeList);
      commit('setStaticList', staticList);
    });
  },
  // 视频
  getVideoList({ state, commit }, page) {
    const {
      videoList,
      videoMetal: { current_page = 0 },
    } = state;
    const thisPage = page || current_page + 1;
    return getVideoList({
      tags: '2020广州车展',
    }).then((res) => {
      let newPrizeList = [];
      if (thisPage === 1) {
        newPrizeList = res.data.data;
      } else {
        newPrizeList = [...videoList, ...res.data.data];
      }
      commit('setVideoList', newPrizeList);
      commit('setVideoMetal', res.data.total);
    });
  },
  clickVideo({ commit, dispatch }, item) {
    commit('setVideoInfo', item);
    dispatch('changeVideo', true);
  },
  changeVideo({ commit, state }, bool) {
    const videoShow = bool ?? !state.videoShow;
    commit('setVideoShow', videoShow);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
